
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

export const ADD_QUOTE_CALCULATION = '[QUOTE_CALCULATION] Add';
export const REMOVE_QUOTE_CALCULATION = '[QUOTE_CALCULATION] Remove';

// AddPersonalDetails
export class AddQuoteCalculation implements Action {
    readonly type = ADD_QUOTE_CALCULATION;

    constructor(public payload) { }
}
// RemovePersonalDetails
export class RemoveQuoteCalculation implements Action {
    readonly type = REMOVE_QUOTE_CALCULATION;

    constructor(public payload: number) { }
}

export type Actions = AddQuoteCalculation | RemoveQuoteCalculation;
